import createSvgIcon from "@ixigo/icons/utils/createSvgIcon";

export const LeftStar = createSvgIcon(
  <svg
    width="28"
    height="14"
    viewBox="0 0 28 14"
    fill="none"
    transform="translate(0,5)"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 0.5L20.6635 6.16349L15 7L20.6635 7.83651L21.5 13.5L22.3365 7.83651L28 7L22.3365 6.16349L21.5 0.5Z"
      fill="#FAFAFA"
    />
    <rect
      width="19"
      height="1"
      transform="matrix(-1 0 0 1 19 6.5)"
      fill="url(#paint0_linear_5113_66910)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5113_66910"
        x1="0"
        y1="0.5"
        x2="19"
        y2="0.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>,
  "LeftStar"
);
